import { Dates } from '../MinMaxDate';

export const dateRangeValidator = ({ startDate, endDate }: Dates) => {
  if (!startDate || !endDate || startDate === endDate) return true;
  return new Date(startDate) < new Date(endDate);
};
